<template>
  <div>
    <div>
      <el-button
        style="margin-bottom: 10px"
        type="primary"
        icon="el-icon-plus"
        @click="openDialog(true, null)"
        >新增白名单项</el-button
      >
    </div>

    <el-table
      :data="list"
      border
      size="small"
      style="width: 481px"
      height="450px"
      :infinite-scroll-disabled="list.length == 0"
    >
      <el-table-column prop="aid" label="Aid" align="center" width="100">
      </el-table-column>

      <el-table-column
        prop="remark"
        label="备注"
        show-overflow-tooltip
        align="center"
        width="200"
      >
      </el-table-column>

      <el-table-column label="操作" align="center" width="180">
        <template slot-scope="scope">
          <el-button type="danger" round size="mini" @click="remove(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";
const dialogutil = require("@/dialogutil");

export default {
  data() {
    return {
      list: [], // 白名单列表里展示的数据
    };
  },

  created() {
    this.loadList();
  },

  methods: {
    /**
     * 拉取白名单
     */
    async loadList() {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/whiteListEntry/queryWhiteListEntryForGm`,
          {},
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }

      let listInResponse = resData.data.list || [];

      this.list = listInResponse;
    },

    /**
     *打开“添加/修改分区白名单”对话框
     */
    openDialog(isCreate, oldData) {
      dialogutil.open("EditWhiteListEntryOfGmDialog", {
        closedCallback: () => {
          this.loadList();
        },
        data: { isCreate: isCreate, form: oldData },
      });
    },

    /**
     * 删除
     */
    async remove(entry) {
      try {
        // 弹确认框
        await this.$confirm(`确认删除白名单AID：${entry.aid}？`);

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/whiteListEntry/operationWhiteListEntryForGm`,
            {
              operation: "delete",
              entry: entry,
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }
        this.$message({
          message: "删除成功",
          type: "success",
        });

        for (let i = 0; i < this.list.length; i++) {
          if (this.list[i].aid == entry.aid) {
            this.list.splice(i, 1);
            break;
          }
        }
      } catch (e) {}
    },
  },
};
</script>